<template>
  <el-dialog :visible.sync="show" :title="$t('m.live_viola_record')" @close="onDialogClose('theForm')" :close-on-click-modal="false" :append-to-body="true">
    <el-form size="small" :inline="true" :model="model" ref="theForm">
      <el-row :gutter="10">
        <el-col :sm="15" :xs="24">
          <el-form-item prop="operationTimeStart">
            <el-date-picker v-model="model.operationTimeStart" type="datetime" :placeholder="$t('m.violation_time')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <span class="coldiv">~</span>
          <el-form-item prop="operationTimeEnd">
            <el-date-picker v-model="model.operationTimeEnd" type="datetime" :placeholder="$t('m.violation_time')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-button @click="onQueryBtnClick" type="primary" size="mini">{{$t('m.search')}}</el-button>
      <el-button type="text" size="mini" @click="$refs.theForm.resetFields()">{{$t('m.reset')}}</el-button>
    </el-form>
    <br>
    <br>
    <div class="overline">
      <el-table :data="tableData" v-loading="loading.table" border max-height="400">
        <el-table-column :label="$t('m.sereamer_nickname')" prop="nickName"></el-table-column>
        <el-table-column :label="$t('m.violation_reason')" prop="operationReason" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('m.violation_time')" prop="operationTime"></el-table-column>
        <el-table-column :label="$t('m.live_state_placeholder')" prop="liveFlagName"></el-table-column>
        <el-table-column :label="$t('m.processing_result')" prop="hour">
          <template slot-scope="scope">
            <span v-if="scope.row.hour === -1">{{$t('m.permanent')}}</span>
            <!-- 分钟 -->
            <span v-else-if="scope.row.hour === 1">{{$t('m.minute',{'msg_ss':15})}}</span>
            <span v-else-if="scope.row.hour === 2">{{$t('m.minute',{'msg_ss':30})}}</span>
            <span v-else-if="scope.row.hour === 3">{{$t('m.xx_hour',{'msg_ss':1})}}</span>
            <span v-else-if="scope.row.hour === 4">{{$t('m.xx_hours',{'msg_ss':12})}}</span>
            <span v-else-if="scope.row.hour === 5">{{$t('m.xx_hours',{'msg_ss':24})}}</span>
            <span v-else-if="scope.row.hour === 6">{{$t('m.xx_hours',{'msg_ss':48})}}</span>
            <span v-else-if="scope.row.hour === 7">{{$t('m.xx_days',{'msg_ss':30})}}</span>
            <span v-else-if="scope.row.hour === 8">{{$t('m.xx_days',{'msg_ss':5})}}</span>
            <span v-else-if="scope.row.hour === 9">{{$t('m.xx_days',{'msg_ss':7})}}</span>
            <span v-else-if="scope.row.hour === 10">{{$t('m.xx_days',{'msg_ss':15})}}</span>
            <span v-else-if="scope.row.hour === 11">{{$t('m.xx_year',{'msg_ss':1})}}</span>
            <span v-else-if="scope.row.hour === 12">{{$t('m.xx_years',{'msg_ss':3})}}</span>
            <span v-else></span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <el-pagination @size-change="onSizeChange" @current-change="onCurrentPageChange" :current-page="pager.page"
        :page-sizes="[10, 20, 30]" :page-size="pager.limit" small layout="total, sizes, prev, pager, next, jumper"
        :total="pager.total" :pager-count="5"></el-pagination> -->
    </div>
  </el-dialog>
</template>

<script>

import {getLiveViolationLog} from '../../../api/approval/anchor-approval';

export default {
  name: 'user-label-add-dialog',

  data() {
    return {
      loading: {
        table: true,
        btn: false
      },
      tableData: [],
      show: false,
      model: {
        operationTimeStart: null,
        operationTimeEnd: null,
        id: null,
        userId:null
      },
      pager: {
        page: 1,
        limit: 10000,
        total: 0
      },
      row: null
    };
  },

  methods: {
    activeInputElement() {
      document.activeElement.blur();
      this.$nextTick(() => {
          let inputTime = document.querySelectorAll('.el-input__inner')
          inputTime.forEach(item => {
            item.addEventListener('focus', () => {
              document.activeElement.blur()
            })
          })
        })
    },
    // 搜索
    onQueryBtnClick() {
      this.pager.page = 1;
      this.getTableData();
    },
    // query() {
    //   this.loading.table = true;
    //   this.getTableData();
    // },
    // 页面切换
    onSizeChange(size) {
      this.pager.limit = size;
      this.getTableData();
    },
    // 页面切换
    onCurrentPageChange(page) {
      this.pager.page = page;
      this.getTableData();
    },
    // 显示弹窗
    showDialog(row) {
      console.log(row);
      this.model.id = row.id;
      this.model.userId = row.userId;
      this.getTableData();
      this.show = true;
    },
    // 显示表格数据
    getTableData() {
      this.loading.table = true;
      getLiveViolationLog({
          query: this.model,
          pager: this.pager,
          sorter: this.sorter
      })
        .then(({ data }) => {
          console.log(111111);
          this.tableData = data.data.list;
          this.pager.total = data.data.total;
          this.loading.table = false;
        })
        .catch(error => {
          console.log(error);
          this.loading.table = false;
          // if(error.code==500){
          //   this.$message.error(this.$t('m.network_busy'))
          // }
        });
    },

    onDialogClose(formRef) {
      // this.$emit('done');
      this.tableData=null;
      this.$refs[formRef].resetFields();
    }
  }
};
</script>
<style scoped>
  .ab_label {
    position: absolute;
    right:0;
    top: 0;
    width: 0;
    height: 0;
    border-top: 10px solid #55aaff;
    border-left: 10px solid transparent;
  }
 .cd_label {
    border-top: 10px solid #55aa7f;
  }

  @media screen and (max-width: 480px) {
  	.coldiv {font-size: 13px;}
    .el-date-editor.el-input {
      width: 119px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/approval/dialogs/liveViolationLogDialog.vue